// extracted by mini-css-extract-plugin
module.exports = {"navbarContainer":"Navbar_navbarContainer__AtMnP","avatarBtn":"Navbar_avatarBtn__x7PD3","statusText":"Navbar_statusText__4kLoG"};